export type ToastVariant = "success" | "error" | "warning" | "info" | "danger";

export interface ToastData {
  title: string;
  content: string;
  iconName?: string; // Optional - will use default based on variant
}

export interface ToastConfig {
  iconName: string;
  iconClassName: string;
  backgroundColor: string;
}

export const TOAST_CONFIG: Record<ToastVariant, ToastConfig> = {
  success: {
    iconName: "icon-toast-success",
    iconClassName: "successColor",
    // backgroundColor: "#212E3A",
    backgroundColor: "#ffffffff",
  },
  error: {
    iconName: "icon-toast-error",
    iconClassName: "errorColor",
    backgroundColor: "#2A1F1F",
  },
  warning: {
    iconName: "icon-toast-warning",
    iconClassName: "warningColor",
    backgroundColor: "#2A2A1F",
  },
  info: {
    iconName: "icon-toast-info",
    iconClassName: "infoColor",
    backgroundColor: "#1F2A2A",
  },
  danger: {
    iconName: "icon-toast-danger",
    iconClassName: "dangerColor",
    backgroundColor: "#3A1F1F",
  },
};
